import { render } from "./SupplierContactModal.vue?vue&type=template&id=4023beb2&scoped=true&ts=true&lang=pug"
import script from "./SupplierContactModal.vue?vue&type=script&lang=ts"
export * from "./SupplierContactModal.vue?vue&type=script&lang=ts"

import "./SupplierContactModal.vue?vue&type=style&index=0&id=4023beb2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4023beb2"]])

export default __exports__